/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { Merchant } from "../../../../models";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MerchantDetailsParentComponent } from "../../merchant-details-parent.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService, MerchantService, NotificationService, SharedFormService } from "../../../../services";
import { MERCHANT_CONSTANTS } from "../../../../utils/data.rest.constants";

@Component({
  selector: "app-wp-customer-contact",
  templateUrl: "./wp-customer-contact.component.html"
})
export class WpCustomerContactComponent extends MerchantDetailsParentComponent implements OnInit {
  customerContactForm!: FormGroup;
  editable = false;
  actionInProgress = false;
  buttonName = "Update Customer Contact Info";
  @Input("merchant") merchant!: Merchant;

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    merchantService: MerchantService,
    notificationService: NotificationService,
    authService: AuthService,
    private fb: FormBuilder,
    private sharedFormService: SharedFormService
  ) {
    super(router, activatedRoute, merchantService, notificationService, authService);
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.customerContactForm = this.fb.group({
      contacts: this.sharedFormService.getContactsForm(this.merchant)
    });
  }

  updateCustomerContact(): void {
    if (this.customerContactForm.valid) {
      this.actionInProgress = true;
      this.setFeeDetailsToNullIfNoneExist(this.merchant);
      const tempMerchant: Merchant = JSON.parse(JSON.stringify(this.merchant));
      this.sharedFormService.updateCustomerContact(tempMerchant, this.contactsFormGroup);
      tempMerchant.statementOptions = {};
      if (!this.authService.getUserRole(MERCHANT_CONSTANTS.FINANCE)) {
        tempMerchant.contractedRates = null as any;
      }
      this.merchantService.updateElementMerchant("CONTACTS", tempMerchant).subscribe(
        (merchant) => {
          this.merchant = merchant;
          this.editable = false;
          this.actionInProgress = false;
        },
        (error) => {
          this.notificationService.error(error.error);
        }
      );
    }
  }

  get contactsFormGroup(): FormGroup {
    return this.customerContactForm.controls["contacts"] as FormGroup;
  }

  setEditable(value: boolean): void {
    this.editable = value;
  }

  receiveEditEvent(value: boolean) {
    this.editable = value;
    this.createForm();
  }
}
